import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { environment } from 'environments/environment';
import {SecurityService} from '@app/core/security/service/security.service';
import { EventType } from '../security/service/security.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class LocalizationService {

  public labels: { [key: string]: string };

  constructor(
    private readonly injector: Injector,
    private httpClient: HttpClient) {
  }

  getLabel(key: string): any {
    if (!this.labels) { window.location.reload(); }

    return this.labels[key];
  }

  
  loadLabels(country: string, onLabelsLoaded: () => void): void {
    this.httpClient.get<{ [key: string]: string }>(`assets/localization/${country}.json`, { params: { noHeader: 'true', baseurl: 'false' }}).pipe(
      catchError(err => {
        this.labels = { };
        return throwError(err);
      })
    ).subscribe((l) => {
      this.labels = l;
      onLabelsLoaded();

      this.injector.get(SecurityService).authenticationStatus$.next(EventType.LOGIN_SUCCESS);
    });
  }
}
